﻿import { writable } from 'svelte/store';

export const notify = writable({ message: null, timeout: null });
export const tag = writable({ command: null, container: null });